import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["dir"]
const _hoisted_2 = { class: "max-w-7xl mx-auto" }
const _hoisted_3 = { class: "mb-8" }
const _hoisted_4 = { class: "bg-white/80 dark:bg-[#1a1a1a]/90 backdrop-blur-xl rounded-2xl shadow-lg border border-white/20 dark:border-[#374151]/50 overflow-hidden" }
const _hoisted_5 = { class: "bg-gradient-to-r from-[#667eea] to-[#764ba2] p-6" }
const _hoisted_6 = { class: "flex items-center justify-between" }
const _hoisted_7 = { class: "flex items-center gap-4" }
const _hoisted_8 = { class: "text-xl font-bold text-white" }
const _hoisted_9 = { class: "text-white/80 text-sm" }
const _hoisted_10 = {
  key: 0,
  class: "bg-amber-400/20 text-amber-100 px-4 py-2 rounded-xl text-sm font-medium border border-amber-300/30 backdrop-blur-sm"
}
const _hoisted_11 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-20"
}
const _hoisted_12 = { class: "mt-4 text-base font-medium text-[#667eea]" }
const _hoisted_13 = {
  key: 1,
  class: "bg-red-50/80 dark:bg-red-900/20 backdrop-blur-xl rounded-2xl shadow-lg border border-red-200/50 dark:border-red-800/30 p-6 mb-8"
}
const _hoisted_14 = { class: "flex items-start gap-4" }
const _hoisted_15 = { class: "text-lg font-semibold text-red-700 dark:text-red-400" }
const _hoisted_16 = { class: "text-red-600 dark:text-red-300 mt-1" }
const _hoisted_17 = {
  key: 2,
  class: "grid grid-cols-1 lg:grid-cols-4 gap-8"
}
const _hoisted_18 = { class: "lg:col-span-3 space-y-8" }
const _hoisted_19 = { class: "bg-white/80 dark:bg-[#1a1a1a]/90 backdrop-blur-xl rounded-2xl shadow-lg border border-white/20 dark:border-[#374151]/50 overflow-hidden group hover:shadow-xl transition-all duration-300" }
const _hoisted_20 = { class: "bg-gradient-to-r from-[#4facfe] to-[#00f2fe] p-5" }
const _hoisted_21 = { class: "text-lg font-bold text-white flex items-center" }
const _hoisted_22 = { class: "p-6" }
const _hoisted_23 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6" }
const _hoisted_24 = { class: "md:col-span-2" }
const _hoisted_25 = { class: "block text-sm font-semibold text-[#374151] dark:text-[#E2E8F0] mb-3" }
const _hoisted_26 = ["disabled", "placeholder"]
const _hoisted_27 = { class: "block text-sm font-semibold text-[#374151] dark:text-[#E2E8F0] mb-3" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = { value: "" }
const _hoisted_30 = { value: "Digital Product" }
const _hoisted_31 = { value: "Physical Product" }
const _hoisted_32 = { value: "Service" }
const _hoisted_33 = { class: "block text-sm font-semibold text-[#374151] dark:text-[#E2E8F0] mb-3" }
const _hoisted_34 = ["disabled", "placeholder"]
const _hoisted_35 = { class: "block text-sm font-semibold text-[#374151] dark:text-[#E2E8F0] mb-3" }
const _hoisted_36 = ["disabled", "placeholder"]
const _hoisted_37 = { class: "block text-sm font-semibold text-[#374151] dark:text-[#E2E8F0] mb-3" }
const _hoisted_38 = ["disabled", "placeholder"]
const _hoisted_39 = { class: "md:col-span-2" }
const _hoisted_40 = { class: "block text-sm font-semibold text-[#374151] dark:text-[#E2E8F0] mb-3" }
const _hoisted_41 = ["disabled", "placeholder"]
const _hoisted_42 = { class: "bg-white/80 dark:bg-[#1a1a1a]/90 backdrop-blur-xl rounded-2xl shadow-lg border border-white/20 dark:border-[#374151]/50 overflow-hidden group hover:shadow-xl transition-all duration-300" }
const _hoisted_43 = { class: "bg-gradient-to-r from-[#fa709a] to-[#fee140] p-5" }
const _hoisted_44 = { class: "text-lg font-bold text-white flex items-center" }
const _hoisted_45 = { class: "p-6" }
const _hoisted_46 = { class: "grid grid-cols-1 md:grid-cols-3 gap-6" }
const _hoisted_47 = { class: "block text-sm font-semibold text-[#374151] dark:text-[#E2E8F0] mb-3" }
const _hoisted_48 = { class: "relative" }
const _hoisted_49 = ["disabled", "placeholder"]
const _hoisted_50 = { class: "block text-sm font-semibold text-[#374151] dark:text-[#E2E8F0] mb-3" }
const _hoisted_51 = { class: "relative" }
const _hoisted_52 = ["disabled", "placeholder"]
const _hoisted_53 = { class: "block text-sm font-semibold text-[#374151] dark:text-[#E2E8F0] mb-3" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = { class: "bg-white/80 dark:bg-[#1a1a1a]/90 backdrop-blur-xl rounded-2xl shadow-lg border border-white/20 dark:border-[#374151]/50 overflow-hidden group hover:shadow-xl transition-all duration-300" }
const _hoisted_56 = { class: "bg-gradient-to-r from-[#a8edea] to-[#fed6e3] p-5" }
const _hoisted_57 = { class: "text-lg font-bold text-gray-700 flex items-center" }
const _hoisted_58 = { class: "p-6" }
const _hoisted_59 = { class: "flex items-start gap-6" }
const _hoisted_60 = {
  key: 0,
  class: "w-24 h-24 rounded-2xl overflow-hidden border-2 border-white shadow-lg flex-shrink-0"
}
const _hoisted_61 = ["src"]
const _hoisted_62 = {
  key: 1,
  class: "flex-1"
}
const _hoisted_63 = { class: "relative flex items-center justify-center rounded-2xl py-8 px-6 border-2 border-dashed border-[#a8edea] hover:border-[#84d3d0] transition-all duration-300 bg-gradient-to-br from-[#a8edea]/10 to-[#fed6e3]/10 hover:from-[#a8edea]/20 hover:to-[#fed6e3]/20 group" }
const _hoisted_64 = { class: "text-center" }
const _hoisted_65 = { class: "text-base font-semibold text-gray-700 mb-2" }
const _hoisted_66 = { class: "text-sm text-gray-500" }
const _hoisted_67 = { class: "space-y-8" }
const _hoisted_68 = { class: "bg-white/80 dark:bg-[#1a1a1a]/90 backdrop-blur-xl rounded-2xl shadow-lg border border-white/20 dark:border-[#374151]/50 overflow-hidden group hover:shadow-xl transition-all duration-300" }
const _hoisted_69 = { class: "bg-gradient-to-r from-[#fbc2eb] to-[#a6c1ee] p-5" }
const _hoisted_70 = { class: "text-lg font-bold text-gray-700 flex items-center" }
const _hoisted_71 = { class: "p-6" }
const _hoisted_72 = { class: "block text-sm font-semibold text-[#374151] dark:text-[#E2E8F0] mb-3" }
const _hoisted_73 = ["disabled", "placeholder"]
const _hoisted_74 = { class: "text-xs text-gray-500 mt-2" }
const _hoisted_75 = {
  key: 0,
  class: "flex flex-wrap gap-2 mt-4"
}
const _hoisted_76 = {
  key: 0,
  class: "bg-white/80 dark:bg-[#1a1a1a]/90 backdrop-blur-xl rounded-2xl shadow-lg border border-white/20 dark:border-[#374151]/50 overflow-hidden"
}
const _hoisted_77 = { class: "p-6" }
const _hoisted_78 = { class: "space-y-4" }
const _hoisted_79 = ["disabled"]
const _hoisted_80 = {
  key: 0,
  class: "inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"
}
const _hoisted_81 = {
  key: 1,
  class: "material-symbols-outlined text-lg"
}
const _hoisted_82 = { class: "bg-white/80 dark:bg-[#1a1a1a]/90 backdrop-blur-xl rounded-2xl shadow-lg border border-white/20 dark:border-[#374151]/50 overflow-hidden" }
const _hoisted_83 = { class: "bg-gradient-to-r from-[#84fab0] to-[#8fd3f4] p-5" }
const _hoisted_84 = { class: "text-lg font-bold text-gray-700 flex items-center" }
const _hoisted_85 = { class: "p-6" }
const _hoisted_86 = { class: "space-y-4" }
const _hoisted_87 = { class: "flex items-center justify-between" }
const _hoisted_88 = { class: "text-sm font-medium text-gray-600" }
const _hoisted_89 = { class: "inline-flex items-center px-3 py-1 rounded-full bg-gradient-to-r from-green-100 to-green-200 text-green-700 text-sm font-semibold border border-green-300" }
const _hoisted_90 = { class: "flex items-center justify-between" }
const _hoisted_91 = { class: "text-sm font-medium text-gray-600" }
const _hoisted_92 = { class: "text-sm font-semibold text-gray-800" }
const _hoisted_93 = { class: "flex items-center justify-between" }
const _hoisted_94 = { class: "text-sm font-medium text-gray-600" }
const _hoisted_95 = { class: "text-sm font-semibold text-gray-800" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "min-h-screen bg-gradient-to-br from-[#FAFBFF] via-[#F8FAFF] to-[#F0F7FF] dark:from-[#0a0a0a] dark:to-[#1a1a1a] p-6",
    dir: _ctx.isRtl ? 'rtl' : 'ltr'
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveProduct && _ctx.saveProduct(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[12] || (_cache[12] = _createElementVNode("div", { class: "w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm" }, [
                    _createElementVNode("i", { class: "material-symbols-outlined text-white text-xl" }, "edit_note")
                  ], -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.directT('ecommerce.editProduct.title')), 1),
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.product.title || _ctx.directT('ecommerce.editProduct.subtitle')), 1)
                  ])
                ]),
                (_ctx.isExternalProduct)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _cache[13] || (_cache[13] = _createElementVNode("i", { class: "material-symbols-outlined mr-2 text-sm" }, "lock", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.editProduct.readOnly')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "relative" }, [
                _createElementVNode("div", { class: "w-12 h-12 border-4 border-[#667eea]/20 border-t-[#667eea] rounded-full animate-spin" }),
                _createElementVNode("div", {
                  class: "absolute inset-0 w-12 h-12 border-4 border-transparent border-r-[#764ba2] rounded-full animate-spin",
                  style: {"animation-delay":"-0.5s"}
                })
              ], -1)),
              _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.directT('ecommerce.editProduct.loadingProduct')), 1)
            ]))
          : (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "w-10 h-10 bg-red-500/10 rounded-xl flex items-center justify-center" }, [
                    _createElementVNode("i", { class: "material-symbols-outlined text-red-500 text-xl" }, "error")
                  ], -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_15, _toDisplayString(_ctx.directT('ecommerce.editProduct.errorLoadingProduct')), 1),
                    _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.error), 1)
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("h2", _hoisted_21, [
                        _cache[16] || (_cache[16] = _createElementVNode("i", { class: "material-symbols-outlined mr-3 text-xl" }, "info", -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.editProduct.basicInformation')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.directT('ecommerce.editProduct.productTitle')), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.product.title) = $event)),
                            disabled: _ctx.isExternalProduct,
                            class: "w-full h-12 rounded-xl bg-gradient-to-r from-[#F8FAFF] to-[#F0F7FF] dark:from-[#0f172a] dark:to-[#1e293b] border border-[#E5E7EB]/50 dark:border-[#4B5563]/50 text-[#1F2937] dark:text-white px-4 text-sm outline-none focus:border-[#4facfe] focus:ring-2 focus:ring-[#4facfe]/20 transition-all duration-300 disabled:opacity-50 disabled:bg-gray-100 shadow-sm",
                            placeholder: _ctx.directT('ecommerce.editProduct.productTitlePlaceholder')
                          }, null, 8, _hoisted_26), [
                            [_vModelText, _ctx.product.title]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.directT('ecommerce.editProduct.productType')), 1),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.product.product_type) = $event)),
                            disabled: _ctx.isExternalProduct,
                            class: "w-full h-12 rounded-xl bg-gradient-to-r from-[#F8FAFF] to-[#F0F7FF] dark:from-[#0f172a] dark:to-[#1e293b] border border-[#E5E7EB]/50 dark:border-[#4B5563]/50 text-[#1F2937] dark:text-white px-4 text-sm outline-none focus:border-[#4facfe] focus:ring-2 focus:ring-[#4facfe]/20 transition-all duration-300 disabled:opacity-50 disabled:bg-gray-100 cursor-pointer shadow-sm"
                          }, [
                            _createElementVNode("option", _hoisted_29, _toDisplayString(_ctx.directT('ecommerce.editProduct.selectType')), 1),
                            _createElementVNode("option", _hoisted_30, _toDisplayString(_ctx.directT('ecommerce.editProduct.digitalProduct')), 1),
                            _createElementVNode("option", _hoisted_31, _toDisplayString(_ctx.directT('ecommerce.editProduct.physicalProduct')), 1),
                            _createElementVNode("option", _hoisted_32, _toDisplayString(_ctx.directT('ecommerce.createProduct.service')), 1)
                          ], 8, _hoisted_28), [
                            [_vModelSelect, _ctx.product.product_type]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.directT('ecommerce.editProduct.category')), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.product.category) = $event)),
                            disabled: _ctx.isExternalProduct,
                            class: "w-full h-12 rounded-xl bg-gradient-to-r from-[#F8FAFF] to-[#F0F7FF] dark:from-[#0f172a] dark:to-[#1e293b] border border-[#E5E7EB]/50 dark:border-[#4B5563]/50 text-[#1F2937] dark:text-white px-4 text-sm outline-none focus:border-[#4facfe] focus:ring-2 focus:ring-[#4facfe]/20 transition-all duration-300 disabled:opacity-50 disabled:bg-gray-100 shadow-sm",
                            placeholder: _ctx.directT('ecommerce.editProduct.categoryPlaceholder')
                          }, null, 8, _hoisted_34), [
                            [_vModelText, _ctx.product.category]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.directT('ecommerce.editProduct.sku')), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.product.sku) = $event)),
                            disabled: _ctx.isExternalProduct,
                            class: "w-full h-12 rounded-xl bg-gradient-to-r from-[#F8FAFF] to-[#F0F7FF] dark:from-[#0f172a] dark:to-[#1e293b] border border-[#E5E7EB]/50 dark:border-[#4B5563]/50 text-[#1F2937] dark:text-white px-4 text-sm outline-none focus:border-[#4facfe] focus:ring-2 focus:ring-[#4facfe]/20 transition-all duration-300 disabled:opacity-50 disabled:bg-gray-100 shadow-sm",
                            placeholder: _ctx.directT('ecommerce.editProduct.skuPlaceholder')
                          }, null, 8, _hoisted_36), [
                            [_vModelText, _ctx.product.sku]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.directT('ecommerce.editProduct.productLink')), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "url",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.product.product_link) = $event)),
                            disabled: _ctx.isExternalProduct,
                            class: "w-full h-12 rounded-xl bg-gradient-to-r from-[#F8FAFF] to-[#F0F7FF] dark:from-[#0f172a] dark:to-[#1e293b] border border-[#E5E7EB]/50 dark:border-[#4B5563]/50 text-[#1F2937] dark:text-white px-4 text-sm outline-none focus:border-[#4facfe] focus:ring-2 focus:ring-[#4facfe]/20 transition-all duration-300 disabled:opacity-50 disabled:bg-gray-100 shadow-sm",
                            placeholder: _ctx.directT('ecommerce.editProduct.productLinkPlaceholder')
                          }, null, 8, _hoisted_38), [
                            [_vModelText, _ctx.product.product_link]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.directT('ecommerce.editProduct.description')), 1),
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.product.description) = $event)),
                            disabled: _ctx.isExternalProduct,
                            rows: "5",
                            class: "w-full rounded-xl bg-gradient-to-r from-[#F8FAFF] to-[#F0F7FF] dark:from-[#0f172a] dark:to-[#1e293b] border border-[#E5E7EB]/50 dark:border-[#4B5563]/50 text-[#1F2937] dark:text-white p-4 text-sm outline-none focus:border-[#4facfe] focus:ring-2 focus:ring-[#4facfe]/20 transition-all duration-300 disabled:opacity-50 disabled:bg-gray-100 resize-none shadow-sm",
                            placeholder: _ctx.directT('ecommerce.editProduct.descriptionPlaceholder')
                          }, null, 8, _hoisted_41), [
                            [_vModelText, _ctx.product.description]
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("h2", _hoisted_44, [
                        _cache[17] || (_cache[17] = _createElementVNode("i", { class: "material-symbols-outlined mr-3 text-xl" }, "payments", -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.editProduct.pricingInformation')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", null, [
                          _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.directT('ecommerce.editProduct.price')), 1),
                          _createElementVNode("div", _hoisted_48, [
                            _cache[18] || (_cache[18] = _createElementVNode("span", { class: "absolute left-4 top-1/2 -translate-y-1/2 text-[#fa709a] font-bold" }, "₪", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.product.price) = $event)),
                              disabled: _ctx.isExternalProduct,
                              class: "w-full h-12 rounded-xl bg-gradient-to-r from-[#F8FAFF] to-[#F0F7FF] dark:from-[#0f172a] dark:to-[#1e293b] border border-[#E5E7EB]/50 dark:border-[#4B5563]/50 text-[#1F2937] dark:text-white pl-10 pr-4 text-sm outline-none focus:border-[#fa709a] focus:ring-2 focus:ring-[#fa709a]/20 transition-all duration-300 disabled:opacity-50 disabled:bg-gray-100 shadow-sm",
                              placeholder: _ctx.directT('ecommerce.editProduct.pricePlaceholder'),
                              step: "0.01"
                            }, null, 8, _hoisted_49), [
                              [_vModelText, _ctx.product.price]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.directT('ecommerce.editProduct.salePrice')), 1),
                          _createElementVNode("div", _hoisted_51, [
                            _cache[19] || (_cache[19] = _createElementVNode("span", { class: "absolute left-4 top-1/2 -translate-y-1/2 text-[#fa709a] font-bold" }, "₪", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.product.compare_at_price) = $event)),
                              disabled: _ctx.isExternalProduct,
                              class: "w-full h-12 rounded-xl bg-gradient-to-r from-[#F8FAFF] to-[#F0F7FF] dark:from-[#0f172a] dark:to-[#1e293b] border border-[#E5E7EB]/50 dark:border-[#4B5563]/50 text-[#1F2937] dark:text-white pl-10 pr-4 text-sm outline-none focus:border-[#fa709a] focus:ring-2 focus:ring-[#fa709a]/20 transition-all duration-300 disabled:opacity-50 disabled:bg-gray-100 shadow-sm",
                              placeholder: _ctx.directT('ecommerce.editProduct.salePricePlaceholder'),
                              step: "0.01"
                            }, null, 8, _hoisted_52), [
                              [_vModelText, _ctx.product.compare_at_price]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.directT('ecommerce.editProduct.publishDate')), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "date",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.product.publish_date) = $event)),
                            disabled: _ctx.isExternalProduct,
                            class: "w-full h-12 rounded-xl bg-gradient-to-r from-[#F8FAFF] to-[#F0F7FF] dark:from-[#0f172a] dark:to-[#1e293b] border border-[#E5E7EB]/50 dark:border-[#4B5563]/50 text-[#1F2937] dark:text-white px-4 text-sm outline-none focus:border-[#fa709a] focus:ring-2 focus:ring-[#fa709a]/20 transition-all duration-300 disabled:opacity-50 disabled:bg-gray-100 shadow-sm"
                          }, null, 8, _hoisted_54), [
                            [_vModelText, _ctx.product.publish_date]
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("h2", _hoisted_57, [
                        _cache[20] || (_cache[20] = _createElementVNode("i", { class: "material-symbols-outlined mr-3 text-xl" }, "image", -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.editProduct.productImage')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        (_ctx.product.image_link)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                              _createElementVNode("img", {
                                src: _ctx.product.image_link,
                                alt: "Product image",
                                class: "w-full h-full object-cover"
                              }, null, 8, _hoisted_61)
                            ]))
                          : _createCommentVNode("", true),
                        (!_ctx.isExternalProduct)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                              _createElementVNode("div", _hoisted_63, [
                                _createElementVNode("div", _hoisted_64, [
                                  _cache[21] || (_cache[21] = _createElementVNode("div", { class: "w-16 h-16 bg-gradient-to-r from-[#a8edea] to-[#fed6e3] rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300" }, [
                                    _createElementVNode("i", { class: "material-symbols-outlined text-gray-600 text-2xl" }, "cloud_upload")
                                  ], -1)),
                                  _createElementVNode("p", _hoisted_65, _toDisplayString(_ctx.directT('ecommerce.editProduct.clickToUpload')), 1),
                                  _createElementVNode("p", _hoisted_66, _toDisplayString(_ctx.directT('ecommerce.editProduct.imageFormats')), 1)
                                ]),
                                _cache[22] || (_cache[22] = _createElementVNode("input", {
                                  type: "file",
                                  id: "fileInput",
                                  accept: "image/*",
                                  class: "absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                                }, null, -1))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("h2", _hoisted_70, [
                        _cache[23] || (_cache[23] = _createElementVNode("i", { class: "material-symbols-outlined mr-3 text-xl" }, "label", -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.editProduct.tags')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_71, [
                      _createElementVNode("label", _hoisted_72, _toDisplayString(_ctx.directT('ecommerce.editProduct.productTags')), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.tagsInput) = $event)),
                        disabled: _ctx.isExternalProduct,
                        class: "w-full h-12 rounded-xl bg-gradient-to-r from-[#F8FAFF] to-[#F0F7FF] dark:from-[#0f172a] dark:to-[#1e293b] border border-[#E5E7EB]/50 dark:border-[#4B5563]/50 text-[#1F2937] dark:text-white px-4 text-sm outline-none focus:border-[#fbc2eb] focus:ring-2 focus:ring-[#fbc2eb]/20 transition-all duration-300 disabled:opacity-50 disabled:bg-gray-100 shadow-sm",
                        placeholder: _ctx.directT('ecommerce.editProduct.tagsPlaceholder')
                      }, null, 8, _hoisted_73), [
                        [_vModelText, _ctx.tagsInput]
                      ]),
                      _createElementVNode("p", _hoisted_74, _toDisplayString(_ctx.directT('ecommerce.editProduct.tagsHint')), 1),
                      (_ctx.parsedTags.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parsedTags, (tag, index) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: index,
                                class: "inline-flex items-center px-3 py-1 rounded-full bg-gradient-to-r from-[#fbc2eb]/20 to-[#a6c1ee]/20 text-gray-700 border border-[#fbc2eb]/30 text-sm font-medium hover:from-[#fbc2eb]/30 hover:to-[#a6c1ee]/30 transition-all duration-200"
                              }, _toDisplayString(tag), 1))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (!_ctx.isExternalProduct)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                        _createElementVNode("div", _hoisted_77, [
                          _createElementVNode("div", _hoisted_78, [
                            _createElementVNode("button", {
                              type: "submit",
                              disabled: _ctx.loading,
                              class: "w-full h-12 bg-gradient-to-r from-[#667eea] to-[#764ba2] text-white font-semibold rounded-xl hover:from-[#5a6fd8] hover:to-[#6a4190] transition-all duration-300 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 transform hover:scale-[1.02]"
                            }, [
                              (_ctx.loading)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_80))
                                : (_openBlock(), _createElementBlock("i", _hoisted_81, "save")),
                              _createTextVNode(" " + _toDisplayString(_ctx.loading ? _ctx.directT('ecommerce.editProduct.saving') : _ctx.directT('ecommerce.editProduct.saveChanges')), 1)
                            ], 8, _hoisted_79),
                            _createElementVNode("button", {
                              type: "button",
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$router.go(-1))),
                              class: "w-full h-12 bg-gradient-to-r from-gray-100 to-gray-200 text-gray-700 font-semibold rounded-xl hover:from-gray-200 hover:to-gray-300 transition-all duration-300 shadow-sm hover:shadow-md transform hover:scale-[1.02]"
                            }, [
                              _cache[24] || (_cache[24] = _createElementVNode("i", { class: "material-symbols-outlined mr-2 text-lg" }, "arrow_back", -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.editProduct.cancel')), 1)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_82, [
                    _createElementVNode("div", _hoisted_83, [
                      _createElementVNode("h3", _hoisted_84, [
                        _cache[25] || (_cache[25] = _createElementVNode("i", { class: "material-symbols-outlined mr-3 text-xl" }, "info", -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.editProduct.status')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_85, [
                      _createElementVNode("div", _hoisted_86, [
                        _createElementVNode("div", _hoisted_87, [
                          _createElementVNode("span", _hoisted_88, _toDisplayString(_ctx.directT('ecommerce.editProduct.status')), 1),
                          _createElementVNode("span", _hoisted_89, [
                            _cache[26] || (_cache[26] = _createElementVNode("div", { class: "w-2 h-2 bg-green-500 rounded-full mr-2 animate-pulse" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.editProduct.active')), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_90, [
                          _createElementVNode("span", _hoisted_91, _toDisplayString(_ctx.directT('ecommerce.editProduct.source')), 1),
                          _createElementVNode("span", _hoisted_92, _toDisplayString(_ctx.isExternalProduct ? _ctx.directT('ecommerce.editProduct.external') : _ctx.directT('ecommerce.editProduct.manual')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_93, [
                          _createElementVNode("span", _hoisted_94, _toDisplayString(_ctx.directT('ecommerce.editProduct.lastUpdated')), 1),
                          _createElementVNode("span", _hoisted_95, _toDisplayString(new Date().toLocaleDateString()), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
      ], 32)
    ])
  ], 8, _hoisted_1))
}